import { DelayedIndicatorComponent } from './actions/delayed-indicator.component';
import { SaveActionComponent } from './actions/save-action.component';
import { ActionBarDirective } from './actions/action-bar.directive';
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DialogComponent } from "./dialog/dialog.component";
import { GlobalDialogComponent } from "./dialog/global-dialog.component";
import { TranslateModule } from '@ngx-translate/core';
import { NogoshIconPipe } from "../shared/icons/nogosh-icon.pipe";

@NgModule({
  declarations: [DelayedIndicatorComponent, SaveActionComponent, ActionBarDirective, DialogComponent, GlobalDialogComponent],
  imports: [CommonModule, FormsModule, TranslateModule, NogoshIconPipe],
  exports: [DelayedIndicatorComponent, SaveActionComponent, ActionBarDirective, DialogComponent, GlobalDialogComponent, TranslateModule],
  providers: [],
})
export class CoreModule {}
